import { Stack } from '@mui/system';
import { mapLanguage } from 'tdc-web-backend/enums/enums';
import { EnumLanguage } from 'tdc-web-backend/enums/enums';
import { Dispatch, SetStateAction } from 'react';
import CompanyWorkingLanguagesEditModal from './components/CompanyWorkingLanguagesEditModal';
import CustomChip from '../../../../../../../../../components/custom-chip/CustomChip';
import { truncate } from '../../../../../../../../../utils/helpers';
import useUserCompany from '../../../../../../../../../utils/hooks/useUserCompany';
import { CHIP_LABEL_TRUNCATE_VALUE } from '../../../../../../../../../utils/constants';
import { useTranslation } from 'react-i18next';

interface CompanyWorkingLanguagesProps {
  isEditModalOpen: boolean;
  setIsEditModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CompanyWorkingLanguages = ({
  isEditModalOpen,
  setIsEditModalOpen,
}: CompanyWorkingLanguagesProps) => {
  const { t } = useTranslation();
  const { company: companyData } = useUserCompany();

  return (
    <Stack
      direction="row"
      gap={1}
      flexWrap="wrap"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      {companyData?.languages?.map((language: EnumLanguage) => (
        <CustomChip
          key={language}
          tooltipTitle={t(mapLanguage.get(language) ?? '', { ns: 'enum' })}
          label={
            language &&
            truncate(
              t(mapLanguage.get(language) ?? '', { ns: 'enum' }),
              CHIP_LABEL_TRUNCATE_VALUE as number,
            )
          }
          sx={{ width: 'fit-content', textTransform: 'capitalize' }}
        />
      ))}

      {companyData && isEditModalOpen && (
        <CompanyWorkingLanguagesEditModal
          isEditModalOpen={isEditModalOpen}
          setIsEditModalOpen={setIsEditModalOpen}
        />
      )}
    </Stack>
  );
};

export default CompanyWorkingLanguages;
